import {
  Model,
  ResponseFill,
  HttpIgnore,
  ValidationRequired,
  ValidationCNPJ,
  IResource, ObjectCollection,
} from 'simpli-web-sdk'
import moment from 'moment'
import * as Helper from '@/helpers'
import {ItrackCollection} from '@/helpers'
import {Region} from '@/enums/Region'
import {UF} from '@/enums/UF'
import {DeliveryAudit} from '@/enums/DeliveryAudit'

@HttpIgnore()
export default class AuditByDeliveryRequest extends Model {
  readonly $name: string = 'AuditByDeliveryRequest'

  allAudit = ItrackCollection.allAuditGeo.prependNull('app.all')
  allAuditoriaMotivoFiltro = ItrackCollection.allAuditoriaMotivoFiltro.prependNull('app.all')
  allStatusNotificacaoAuditoria = ItrackCollection.allStatusNotificacaoAuditoria.prependNull('app.all')
  allDocs = new ObjectCollection()
  allCte = new ObjectCollection()

  @ResponseFill('auditoria')
  audit: DeliveryAudit | null = null

  @ResponseFill()
  manifesto: string | null = null

  @ResponseFill('start')
  startDate: string | null = null

  endDate: string | null = null

  @ResponseFill('idMotivoAuditoria')
  @ValidationRequired()
  idMotivoAuditoria: number | null = null

  @ResponseFill('nroFiscal')
  docs: string | null = null

  @ResponseFill('searchByCTE')
  searchByCTE: string | null = null

  @ResponseFill('idStatusNotificacaoAuditoria')
  idStatusNotificacaoAuditoria: number | null = null

  @ResponseFill()
  get end() {
    // we should send the next day to the server, the prop endDate is used only to control what the user input
    return !this.endDate ? this.endDate : moment(this.endDate).add(1, 'day').format()
  }

  set end(val) {
    if (val) {
      // in the way back we need to subtract, so the params in the route dont mess up
      this.endDate = moment(val).subtract(1, 'day').format()
    }
  }

  get auditResource() {
    return this.allAudit.get(this.audit)
  }
  set auditResource(val: IResource | null) {
    this.audit = val && val.$id as DeliveryAudit || null
  }

  get auditoriaMotivoResource() {
    return this.allAuditoriaMotivoFiltro.get(this.idMotivoAuditoria)
  }
  set auditoriaMotivoResource(val: IResource | null) {
    this.idMotivoAuditoria = val && val.$id as number || null
  }

  get statusNotificacaoAuditoriaResource() {
    return this.allStatusNotificacaoAuditoria.get(this.idStatusNotificacaoAuditoria)
  }
  set statusNotificacaoAuditoriaResource(val: IResource | null) {
    this.idStatusNotificacaoAuditoria = val && val.$id as number || null
  }

  get docsResource() {
    const str = String(this.docs || '')
    const docs = str.split(',')
    return this.allDocs.getMany(docs)
  }
  set docsResource(val: IResource[]) {
    this.docs = val.map((item: IResource) => item.$id).join(',')
  }

  cleanDocs() {
    this.docs = ''
  }

  populateAllDocs(val: IResource[]) {
    this.allDocs = new ObjectCollection(val)
  }

  get cteResource() {
    const str = String(this.searchByCTE || '')
    const cte = str.split(',')
    return this.allCte.getMany(cte)
  }
  set cteResource(val: IResource[]) {
    this.searchByCTE = val.map((item: IResource) => item.$id).join(',')
  }

  cleanSearchByCTE() {
    this.searchByCTE = ''
  }

  populateSearchByCTE(val: IResource[]) {
    this.allCte = new ObjectCollection(val)
  }
}
